import Client from './client';

export default class Notifications extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postRiskified(options = {}) {
    return this.makeRequest(`${this.host}/fraud/notifications/riskified`, {
      ...options,
       method: 'POST',
    });
  }

}
